import { render } from "./SekretariatiKpk.vue?vue&type=template&id=42256314&scoped=true"
import script from "./SekretariatiKpk.vue?vue&type=script&lang=js"
export * from "./SekretariatiKpk.vue?vue&type=script&lang=js"

import "./SekretariatiKpk.vue?vue&type=style&index=0&id=42256314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42256314"]])

export default __exports__